const SimpleCardContainer = ({ children }) => {
  return (
    <div className="grow bg-white rounded-md drop-shadow-md">
      <div className="flex flex-col divide-y divide-slate-200">{children}</div>
    </div>
  );
};

const SimpleCardTitle = ({ children }) => (
  <div className="p-2 font-bold bg-slate-300 rounded-t-md text-center">
    {children}
  </div>
);

const SimpleCardContent = ({ children }) => (
  <div className="p-4">{children}</div>
);

export { SimpleCardContainer, SimpleCardTitle, SimpleCardContent };
